import { VolmaContainer } from '../../../../Infrastructure/InversifyInject';
import PropertyHelper from '../../../../Infrastructure/Services/PropertyHelper';
import { VolmaTableService } from '../../../../Infrastructure/Services/VomaTableService';
import { Types } from '../../../../Infrastructure/Types';
import { BaseValidator } from '../../../../Infrastructure/Validation/BaseValidator';
import { VolmaInputValidator } from '../../../../Infrastructure/Validation/VolmaInputValidatorValidator';
import { IVolmaTableColumn } from '../../../Table/VolmaTable/IVolmaTableProps';
import VolmaFile from '../../../VolmaFile/index';
import VolmaInput from '../../../VolmaInput/index';
import { IVolmaInputProps } from '../../../VolmaInput/IVolmaInputProps';
import VolmaNumber from '../../../VolmaNumber';
import VolmaSelect from '../../../VolmaSelect/index';
import { BaseEntityService } from '../../BaseEntity/BaseEntityService';
import { IBaseEntityProps } from '../../BaseEntity/IBaseEntityProps';
import { IEntityReducer } from '../../BaseEntity/IEntityReducer';
import { DeliveryMarkAsDeliveredDTO } from './DeliveryMarkAsDeliveredDTO';
import { injectable } from 'inversify';
import * as React from 'react';
import i18next from '../../../i18n';


@injectable()
export class DeliveryMarkAsDeliveredEntityService extends BaseEntityService<DeliveryMarkAsDeliveredDTO, {}>{
    private _volmaTableService: VolmaTableService;
    private _inputValidator: BaseValidator<IVolmaInputProps>;

    constructor() {
        super();

        this._volmaTableService = VolmaContainer.get<VolmaTableService>(Types.VolmaTableService);
        this._inputValidator = VolmaContainer.get<VolmaInputValidator>(Types.VolmaInputValidator);
    }

    public GetColumnsList(): Array<IVolmaTableColumn> {
        return [];
    }

    public GetHeaderEditor(props: IBaseEntityProps<DeliveryMarkAsDeliveredDTO, {}>): JSX.Element {
        return undefined;
    }

    public GetEditorModal(props: IBaseEntityProps<DeliveryMarkAsDeliveredDTO, {}>): JSX.Element {
        return this.GetOneCommentEditor(props);
    }

    public GetEditor(props: IBaseEntityProps<DeliveryMarkAsDeliveredDTO, {}>): JSX.Element {
        return undefined;
    }

    public InitializeEntity(props: IBaseEntityProps<DeliveryMarkAsDeliveredDTO, {}>): void {
        return undefined;
    }

    public OnAfterDataLoaded(dto: DeliveryMarkAsDeliveredDTO): void {
        return undefined;
    }

    public GetReducer(): IEntityReducer<DeliveryMarkAsDeliveredDTO, {}> {
        return undefined;
    }

    public GetInitialDataHelper(): Object {
        return {};
    }

    private GetOneCommentEditor(props: IBaseEntityProps<DeliveryMarkAsDeliveredDTO, {}>): JSX.Element{
        return (
            <div className={(this._mainInfo()).toString()}>
                <div className={(this._titleDropParent).toString()}>
                    {this.GetMainInfoNoTitleItem(true, false, this.OneCommentPart(props))}
                </div>
            </div>
        );
    }

   private OneCommentPart(props: IBaseEntityProps<DeliveryMarkAsDeliveredDTO, {}>): JSX.Element{
        return (
            <div className={(this._mainInfo("row")).toString()}>
                <div className={this._mainInfo("cell", { 100: true }).toString()}>
                    <div className={this._mainInfo("line", { fill: true }).toString()}>
                        <VolmaInput
                            {...PropertyHelper.GetInputPropertyByName(props.Inputs, (val: DeliveryMarkAsDeliveredDTO) => val.Comment) }
                            Name={PropertyHelper.GetPropertyName((val: DeliveryMarkAsDeliveredDTO) => val.Comment)}
                            Type="textarea"
                            Label={i18next.t('deliverymarkasdelivered:Comment')}
                            Value={props.DataDTO.Comment}
                            Required={true}
                            Validator={this._inputValidator}
                            dispatch={props.dispatch} />
                    </div>
                </div>
                <div className={this._mainInfo("cell", { 100: true }).toString()}>
                    <div className={this._mainInfo("line", { fill: true }).toString()}>
                        <VolmaFile
                            {...(PropertyHelper.GetInputPropertyByName(props.Inputs, (val: DeliveryMarkAsDeliveredDTO) => val.FileId) as any) }
                            Name={PropertyHelper.GetPropertyName((val: DeliveryMarkAsDeliveredDTO) => val.FileId)}
                            Label={i18next.t('deliverymarkasdelivered:FileId')}
                            Value={props.DataDTO.FileId}
                            Required={false}
                            dispatch={props.dispatch} />
                    </div>
                </div>

            </div>
        );
    }
}